import React from 'react';
import { Navigate, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useFreeAuth } from './FreeAuth';
import { LegalFooter } from '../legal/LegalLinks';

const navItems = [
  { to: '/free/dashboard', label: 'Dashboard' },
  { to: '/free/log', label: 'Log Session' },
  { to: '/free/progress', label: 'My Progress' },
  { to: '/free/technique', label: 'Technique Guide' },
  { to: '/free/calculator', label: 'Calculator' },
  { to: '/free/account', label: 'Account' },
];

export default function FreeLayout() {
  const navigate = useNavigate();
  const { status, signOut } = useFreeAuth();

  if (status === 'checking') {
    return <div className="min-h-screen bg-mono-base" data-testid="free-auth-resolving" />;
  }
  if (status === 'out') return <Navigate to="/free" replace />;

  const handleSignOut = async () => {
    await signOut();
    navigate('/free', { replace: true });
  };

  return (
    <div className="min-h-screen bg-mono-base flex flex-col">
      <header className="border-b border-mono-line bg-mono-base/95 backdrop-blur sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between h-14">
            <span className="text-white font-heading text-xs md:text-sm font-bold uppercase tracking-[0.25em]">
              Coach Rands Method
            </span>
            <button
              onClick={handleSignOut}
              className="text-mono-mute hover:text-white transition-colors p-1"
              title="Sign out"
              data-testid="free-signout-btn"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
          <nav className="flex gap-1 overflow-x-auto -mb-px" data-testid="free-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`free-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                className={({ isActive }) =>
                  `whitespace-nowrap px-4 py-3 font-heading text-sm font-semibold uppercase tracking-wider border-b-2 transition-colors ${
                    isActive
                      ? 'text-crimson border-crimson'
                      : 'text-mono-mute border-transparent hover:text-white'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main
        className="flex-1 max-w-5xl w-full mx-auto px-4 md:px-8 py-8 md:py-12"
      >
        <Outlet />
      </main>
      <LegalFooter />
    </div>
  );
}
